// extracted by mini-css-extract-plugin
module.exports = {"authLink":"AuthNav_authLink__TJLPw","authActiveLink":"AuthNav_authActiveLink__19prq"};